module.exports = __webpack_public_path__ + "static/media/acre.b56f6c38.svg";